{
  "GENERAL": {
    "CLOSE": "Zamknij",
    "SHOWING_RESULTS": "Showing {firstIndex}-{lastIndex} of {totalCount} items",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Szukaj",
      "EMPTY_STATE": "Nie znaleziono rekordów"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Wymagane co najmniej {count}"
  }
}
